export function getV2RuntimeFromDll() {
  var _window$BRICK_NEXT_VE;
  const {
    dll
  } = window;
  if (dll && (_window$BRICK_NEXT_VE = window.BRICK_NEXT_VERSIONS) !== null && _window$BRICK_NEXT_VE !== void 0 && (_window$BRICK_NEXT_VE = _window$BRICK_NEXT_VE["brick-container"]) !== null && _window$BRICK_NEXT_VE !== void 0 && _window$BRICK_NEXT_VE.startsWith("2.")) {
    return dll("tYg3");
  }
}
//# sourceMappingURL=getV2RuntimeFromDll.js.map